export default __webpack_public_path__ + "static/media/08.bff6d586.jpg";